import CryptoJS from 'crypto-js';
const CDN_DOMAIN = 'https://media.spyne.ai';

function parseS3Url(url) {
    if (!url || typeof url !== 'string') return null;
    try {
        // Accept both ...s3.amazonaws.com/... and ...s3.<region>.amazonaws.com/...
        const s3Regex = /^([a-zA-Z0-9\-]+)\.s3(?:[.-][a-z0-9-]+)?\.amazonaws\.com$/i;
        const parsed = new URL(url);
        const host = parsed.hostname || '';
        const key = (parsed.pathname || '').replace(/^\/+/, '');
        if (!key) return null;
        const s3Match = s3Regex.exec(host);
        if (s3Match) {
            return { bucket: s3Match[1], key };
        }
        return null;
    } catch {
        return null;
    }
}


function getSecureThumborUrl(imagePath, resolution, filterFormat, secretKey) {
    const parts = [];
    
    parts.push(resolution || '0x0');
    
    parts.push('smart');
    if (filterFormat) {
        parts.push(`filters:format(${filterFormat})`);
    }
    parts.push(imagePath);
    const operationPath = parts.join('/');

    const signature = CryptoJS.HmacSHA1(operationPath, secretKey);
    const base64 = CryptoJS.enc.Base64.stringify(signature);
    const urlSafe = base64.replaceAll('+', '-').replaceAll('/', '_');

    return `${CDN_DOMAIN}/${urlSafe}/${operationPath}`;
}


function getUnsafeThumborUrl(imagePath, resolution, filterFormat) {
    const baseUrl = process.env.REACT_APP_PUBLIC_IMAGE_COMPRESSOR_BASE_URL || `${CDN_DOMAIN}/unsafe`;
    const parts = [baseUrl.replace(/\/+$/, '')];
    if (resolution) parts.push(resolution);
    parts.push(`filters:format(${filterFormat})`, imagePath);
    return parts.join('/');
}

export const IMAGE_COMPRESSOR = (props) => {
    const SECRET_KEY = process.env.REACT_APP_THUMBOR_SECRET_KEY || process.env.THUMBOR_API_KEY;
    const { url, resolution, filterFormate, isOriginal = false } = props;

    if (isOriginal) {
        return url;
    }

    const filterFormat = filterFormate || 'webp';

    const s3 = parseS3Url(url);
    const imagePath = s3 ? `${s3.bucket}/${s3.key}` : url;

    if (SECRET_KEY) {
        return getSecureThumborUrl(imagePath, resolution, filterFormat, SECRET_KEY);
    }

    return getUnsafeThumborUrl(imagePath, resolution, filterFormat);
};
